import ModuleInfo from './ModuleInfo';
import ModuleMetrics from './ModuleMetrics';
import { SvgCanvas } from './svg/SvgCanvas';
import { useRef } from 'react';
import useMouse from '@react-hook/mouse-position';

const ModuleCarousel = () => {
    const ref = useRef(null);
    const mouse = useMouse(ref);

    return (
        <div className="grow relative" ref={ref}>
            <SvgCanvas mouse={mouse} containerElement={ref} />
            <ModuleInfo />
            <ModuleMetrics />
        </div>
    );
};

export default ModuleCarousel;
